export default class OnlineOperationRecordController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineOperationRecord/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineOperationRecord/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/onlineOperationRecord/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineOperationRecord/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineOperationRecord/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineOperationRecord/delete', 'post', params, axiosOption, httpOption);
  }
}
